export default __webpack_public_path__ + "5fcc934.png";